export enum HomeHealthAideInterventionFrequencyTypeEnum {
  EveryVisit = 1,
  Weekly = 2,
  Prn = 3,
  Once = 4,
  Other = 99
}

export const HomeHealthAideInterventionFrequencyTypeOptions = [
{ id: 1, label: 'Every Visit' },
{ id: 2, label: 'Weekly' },
{ id: 3, label: 'Prn' },
{ id: 4, label: 'Once' },
{ id: 99, label: 'Other' }
];
